import React from "react";

const StatusInformation = () => {
  return (
    <div className="news">
      <span>
        <i className="far fa-file-alt fa-beat"></i> Nouveauté !
      </span>
    </div>
  );
};

export default StatusInformation;
